<script setup lang="ts">
import { Tooltip as TooltipRoot, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { TOOLTIP_HOST_ID, tooltipHostState } from '@/shared/directives/tooltip'

// Components
import TooltipRichContent from '@/shared/components/TooltipRichContent.vue'

const { open, text, rich, side, reference } = tooltipHostState
</script>

<template>
  <TooltipProvider disable-hoverable-content>
    <TooltipRoot :open="open">
      <TooltipTrigger
        as-child
        :reference="reference ?? undefined"
      >
        <span class="hidden" />
      </TooltipTrigger>
      <TooltipContent :side="side">
        <div :id="TOOLTIP_HOST_ID">
          <TooltipRichContent
            v-if="rich"
            :header="rich.header"
            :items="rich.items"
            :batches="rich.batches"
          />
          <!-- pre-line: line breaks (\n) in tooltip text split it into lines -->
          <span
            v-else
            class="whitespace-pre-line"
          >{{ text }}</span>
        </div>
      </TooltipContent>
    </TooltipRoot>
  </TooltipProvider>
</template>
